<template>
	<div class="news">
		<div class="news_from" style="margin-top: 100px">
			<div>资讯类型：</div>
			<div class="news_Location">
				<div class="news_Location_item" v-for="(item, index) in news_kind" :key="index"
					@click="handClick(item.id)" :style="(tabIndex==item.id?'color:rgb(26, 127, 221)':'')">
					<img v-if="item.id===4" src="../../static/other/icon-fee.png"  class="img-icon-fee"/>
					<img v-else-if="item.id===6" class="icon-standard" src="../../static/other/icon-standard.png" />
					<span>{{ item.kind }}</span>
				</div>
			</div>
		</div>
		<!-- <div class="news_from">
      <div>新闻属地：</div>
      <div class="news_Location">
        <div class="news_Location_item" v-for="(item,index) in province" :key="index">{{item}}</div>
      </div>
    </div> -->
		<!--收费标准-->
		<div class="standard_con" v-if="news_kind[tabIndex-1].id===6">
			<table>
				<tr>
					<th>类型</th>
					<th>收费标准</th>
					<th>图标</th>
				</tr>
				<tr>
					<td>收费</td>
					<td>￥5/条</td>
					<td><img src="../../static/other/icon-fee.png" class="icon-fee"/></td>
				</tr>
				<tr>
					<td>免费</td>
					<td>免费</td>
					<td><img src="../../static/other/icon-free.png" class="icon-free" /></td>
				</tr>
			</table>
			<h2>图标说明：</h2>
			<p><img src="../../static/other/icon-fee.png" class="icon-fee" /> <span>：表示该内容需要支付5元人民币后方可阅读。</span></p>
			<p><img src="../../static/other/icon-free.png" class="icon-free" /><span>：表示该内容可以免费阅读，无需支付任何费用。</span></p>
			<h2>收费标准细节：</h2>
			<p><span>收费内容：</span>用户支付5元后，即可阅读相应的内容。使用付费时提供的手机号，通过验证码登录后，可以享受无限次重复阅读的权益。</p>
			<p><span>免费内容：</span>用户无需支付任何费用，即可直接阅读。</p>
			<h2>备注：</h2>
			<p>收费标准可能会根据内容的更新和市场情况进行调整，具体以实际展示为准。</p>
			<p>我们承诺将持续优化内容质量和服务体验，以满足用户的多元化需求。</p>
			<p>感谢您的理解与支持，我们期待为您提供优质的内容服务！</p>
		</div>
		<div class="news_con" v-else>
			<div v-for="(item, index) in news_kind[tabIndex-1]['list']" class="news_con_item" :key="index"
				@click="clickArticle(item,news_kind[tabIndex-1].id)">
				<div class="news_con_time">
					<div>{{ item.data }}</div>
				</div>
				<div class="news_text">
					<div class="news_title">
						<!--干货分享：收费优化-->
						<el-tooltip class="item" effect="dark" content="付费阅读" placement="top"
							v-if="news_kind[tabIndex-1].id === 4">
							<img src="../../static/other/icon-fee.png" class="img-icon-fee"/>
						</el-tooltip>
						<el-tooltip class="item" effect="dark" content="免费阅读" placement="top" v-else>
							<img src="../../static/other/icon-free.png" class="img-icon-free" />
						</el-tooltip>
						<span>{{ item.title }}</span>
					</div>
					<div class="news_detail">{{ item.detail }}</div>
				</div>
			</div>
		</div>
		<!-- 手机验证码验证弹窗 -->
		<PhoneCodeYz :visible.sync="loginVisible" v-if="loginVisible" :itemId="itemId" @success="phoneLoginCallback" />
		<!-- 二维码支付弹窗 -->
		<QrcodePay :visible.sync="qrcodeVisible" v-if="qrcodeVisible" :itemId="itemId" :payNo="payNo"
			@close="qrcodePayCallback" />
	</div>
</template>

<script>
	import {
		checkPay
	} from "@/api/basic";
	import PhoneCodeYz from "./components/PhoneCodeYz";
	import QrcodePay from "./components/QrcodePay";
	export default {
		name: "",
		mixins: [],
		components: {
			PhoneCodeYz,
			QrcodePay
		},
		props: {},
		data() {
			return {
				tabIndex: 0,
				province: [
					"北京",
					"上海",
					"内蒙古",
					"广西",
					"黑龙江",
					"江苏",
					"新疆",
					"四川",
					"云南",
				],
				news_kind: [{
						id: 1,
						kind: "公司动态",
						list: [{
                id: 20250505,
                title: "鼎新致远 函通未来——鼎函科技成立三周年记",
                data: '2025-05-05',
                detail: "时光荏苒，鼎函科技有限公司在今日迎来了三周年华诞。"
            }, {
                id: 20250423,
                title: "变“费”为“保”,助企纾困",
                data: '2025-04-23',
                detail: "电子保函有何重要意义？又将如何助企减负？中小企业如何用活、用好电子保函促进自身发展？"
            }, {
                id: 20250331,
                title: "鼎函科技入列中国招标投标协会，开启数字化招投标新篇章",
                data: '2025-03-31',
                detail: "近日，鼎函科技正式获批成为中国招标投标协会（简称“中招协”）会员单位。这标志着鼎函科技在推动行业数字化转型"
            }, {
                id: 20250321,
                title: "“鼎”立科技，“函”启未来",
                data: '2025-03-21',
                detail: "鼎函科技有限公司正式启用全新Logo，以更加简洁、现代的形象，传递出公司“创新引领，追求卓越”的企业精神"
            }, {
                id: 20250311,
                title: "数据资产化：电子保函公司机遇与挑战",
                data: '2025-03-11',
                detail: "随着数字经济的快速发展，数据已成为继土地、劳动力、资本、技术之后的第五大生产要素。数据资产化，即将数据转化为可量化、可交易"
            }, {
                id: 20250227,
                title: "AI赋能国(央)企供应链金融智能化转型",
                data: '2025-02-27',
                detail: "在《招标采购管理》2025年第1期中，鼎函人工智能实验室首席科学家李磊发表了一篇题为《AI赋能国（央）企供应链金融智能化转型》的文章。"
            }, {
                id: 20250117,
                title: "鼎函科技入列中国企业国有产权交易协会理事单位，以电子保函助力构建产权交易新生态",
                data: '2025-01-17',
                detail: "中国企业国有产权交易机构协会第四届会员大会暨第四届理事会第一次会议已于2025年1月16日圆满落下帷幕！"
            }, {
                id: 20250114,
                title: "鼎函科技成功取得“国家级高新技术企业”认证",
                data: '2025-01-14',
                detail: "近日，鼎函科技成功通过“国家高新技术企业”认定。"
            }, {
                id: 20250110,
                title: "助力招标采购数字化转型，获行业协会高度认可",
                data: '2025-01-10',
                detail: "近日，中国招投标协会向鼎函人工智能实验室发来一封感谢信，对我司在推动招投标行业智能化转型方面所做出的突出贡献表示高度赞赏和诚挚感谢。"
            }, {
                id: 20241212,
                title: "鼎函科技成功中标中国南水北调集团电子保函运营服务商",
                data: '2024-12-12',
                detail: "鼎函科技成功中标中国南水北调集团采购与供应链管理数字化平台电子招投标系统电子保函（保险）运营服务商采购项目"
            }, {
								id: 20241206,
								title: "鼎函科技中选中国电能成套设备有限公司电子保函服务机构",
								data: '2024-12-06',
								detail: " 鼎函科技成功中选中国电能成套设备有限公司投标保证金电子保单（保函）服务机构"
							}, {
								id: 20241120,
								title: "鼎函科技拜访河北产权市场",
								data: '2024-11-20',
								detail: " 鼎函科技董事长陈海涛一行赴河北石家庄拜访河北产权市场"
							}, {
								id: 20241119,
								title: "鼎函科技一行拜访西南联合产权交易所及新网银行",
								data: '2024-11-19',
								detail: " 鼎函科技董事长陈海涛一行赴西南联交所及新网银行进行拜访"
							}, {
								id: 20241115,
								title: "浙交所领导莅临鼎函科技交流座谈",
								data: '2024-11-15',
								detail: " 鼎函科技董事长陈海涛在北京总部接待浙江产权交易所"
							}, {
								id: 20241109,
								title: "鼎函科技入选中国通号电子商务平台电子保函系统服务项目",
								data: '2024-11-09',
								detail: " 鼎函科技成功入选中国通号电子商务平台电子保函（保险）建设项目竞争性谈判的遴选"
							},
							{
								id: 20241107,
								title: "鼎函科技一行拜访南方联合产权交易中心及微众银行",
								data: '2024-11-07',
								detail: " 鼎函科技赴广州南方联合产权交易中心及微众银行进行拜访"
							},
							{
								id: 20241024,
								title: "鼎函科技前往延安参加“产权市场助力西部崛起——西部区域产权交易市场融入全国统一大市场建设推进会”",
								data: '2024-10-24',
								detail: " 2024年10月21日—23日，鼎函科技领导带队前往延安参加由中国企业国有产权交易机构协会主办会议"
							},
							{
								id: 20241016,
								title: "公司主要领导拜访中国产权协会",
								data: '2024-10-16',
								detail: " 近日，10月15日上午，鼎函科技董事长陈海涛带队前往拜会中国企业国有产权交易协会"
							},
							{
								id: 20240906,
								title: "中国产权协会吸收鼎函科技成为会员单位",
								data: '2024-09-06',
								detail: " 近日，中国企业国有产权交易机构协会吸收鼎函科技成为会员单位"
							},
							{
								id: 20240923,
								title: "鼎函成功入围丹东市公共资源交易平台接入电子保函服务机构",
								data: '2024-09-13',
								detail: "9月19日，辽宁省丹东市公共资源交易中心发布公告，鼎函科技有限公司成功中标",
							},
							{
								id: 20240828,
								title: "鼎函科技与甘交所集团进一步深度融合",
								data: '2024-08-28',
								detail: " 8月23日鼎函科技有限公司陈秀琳副总经理带队前往甘肃兰州，拜访甘交所集团。"
							},
							{
								id: 20240821,
								title: "鼎函科技领导带队拜访中国电子旗下五家子公司",
								data: '2024-08-21',
								detail: " 中电百联等五家中国电子信息产业集团公司子公司，在南京中电鹏程公司会议室，与鼎函科技有限公司陈海涛董事长一行进行了交流。"
							},
							{
								id: 20240816,
								title: "鼎函科技深入交流，共谋电子保函发展新征程——拜访浙交所及杭交所",
								data: '2024-08-16',
								detail: " 鼎函科技专程前往浙交所及杭交所进行友好访问与深入交流。"
							},
							{
								id: 20240805,
								title: "鼎函科技拜访深圳联合产权交易所，携手共绘电子保函新篇章",
								data: '2024-08-05',
								detail: " 在数字化转型的浪潮中，鼎函科技有限公司积极响应国家号召，全力推进电子保函的普及与应用。"
							},
							{
								id: 20240716,
								title: "立新址，秉初心，上上迁丨鼎函科技有限公司乔迁大吉！",
								data: '2024-07-16',
								detail: " 随着公司规模不断壮大，原有办公环境已经无法满足，鼎函科技有限公司日前喜迁新址"
							},
							{
								id: 20240621,
								title: "喜报|热烈祝贺鼎函科技有限公司安徽分公司正式成立",
								data: '2024-06-21',
								detail: " 2024年6月21日，鼎函科技有限公司第6家分支机构正式落户安徽省，鼎函安徽分公司正式成立。"
							},
							{
								id: 20240523,
								title: "简讯",
								data: '2024-05-23',
								detail: " 5月23日，鼎函科技有限公司(以下简称鼎函科技)副总经理田松一行，拜访了安徽省产权交易中心有限责任公司"
							},
							{
								id: 20240513,
								title: "鼎函科技领导带队拜访广西省多家省属大型企业",
								data: '2024-05-13',
								detail: " 近日，公司总裁陈海涛带队到南宁市，拜访广西省多家省属大型企业，就电子保函及企业大数据应用，进行了深入交流和探讨。",
							},
							{
								id: 20240508,
								title: "历城区农村产权交易平台上线保函系统",
								data: '2024-05-08',
								detail: " 近日历城农村产权交易中心正式上线电子保函服务系统。",
							},
							{
								id: 20240426,
								title: "鼎函科技受邀参加2024中关村论坛年会",
								data: '2024-04-26',
								detail: " 本月4月25日，2024中关村论坛年会开幕式在位于北京市海淀区的中关村国际创新中心举行。",
							},
							{
								id: 20240422,
								title: "产权交易市场再创新高",
								data: '2024-04-22',
								detail: "近日，中国产权交易协会发布了《产权市场2023年度交易成果发布报告》。数据显示，2023年，产权市场全年完成交易项目11726万余宗",
							},
							{
								id: 20240411,
								title: "热烈祝贺中国华电集团有限公司、中国航空发动机集团保函系统上线",
								data: '2024-04-11',
								detail: " 近日，中国华电集团有限公司、中国航空发动机集团电子保函系统正式上线运行。",
							},
							{
								id: 20240320,
								title: "鼎函科技在京接待南京市栖霞高新区领导拜访",
								data: '2024-03-20',
								detail: " 昨日上午，公司主要领导陈海涛，蔡斌，在京接待了南京栖霞高新区管委会黄斌主任、苏和资本季学庆董事长、高新区招商部朱洁部长",
							},
							{
								id: 20240124,
								title: "鼎函科技新疆分公司培训简讯",
								data: '2024-01-24',
								detail: " 2024年1月23日下午17:30，鼎函科技有限公司新疆分公司对企业概况进行了培训。本次培训旨在提高员工对企业的认知",
							},
							{
								id: 20240111,
								title: "鼎函科技入选华电集团电子保函系统服务项目",
								data: '2024-01-11',
								detail: " 今日，鼎函科技成功入选中国华电集团物资有限公司的《ECP平台电子招投标系统电子保函中介服务平台选商》遴选项目",
							},
							{
								id: 20231231,
								title: "二零二四年元旦致辞",
								data: '2023-12-31',
								detail: " 山河永固，岁月无痕，告别2023的匆匆忙忙，我们即将满怀憧憬跨入2024。鼎函科技祝每一位关心和帮助我们的朋友，和谐美满，幸福安康!",
							},
							{
								id: 20231222,
								title: "贺信：鼎函科技有限公司祝贺内蒙古联合交易控股集团注册成立",
								data: '2023-12-22',
								detail: " 立足新的起点，迈上新的征程，开创新的辉煌，值此内蒙古联合交易控股集团有限公司注册成立，鼎函科技有限公司表示最热烈地祝贺!",
							},
							{
								id: 20231214,
								title: "鼎函科技与北京茶叶交易中心有限公司领导进行座谈",
								data: '2023-12-14',
								detail: " 今日上午，公司总经理陈海涛，商务部总经理田松岺，业务经理邹鹏程到北京茶叶交易中心有限公司与北茶中心领导进行座谈。",
							},
							{
								id: 20231107,
								title: "鼎函科技江苏分公司近日与江苏省设备成套股份有限公司签约",
								data: '2023-11-07',
								detail: " 鼎函科技江苏分公司近日与江苏省设备成套股份有限公司（以下简称江苏成套）签约，双方就电子保函应用达成合作。",
							},
							{
								id: 20231023,
								title: "鼎函科技签约中航金网",
								data: '2023-10-23',
								detail: " 今日，鼎函科技有限公司与中航金网（北京）电子商务有限公司完成签约，中航金网隶属于中国航空工业集团",
							},
							{
								id: 20230913,
								title: "鼎函科技拜访新疆产权交易所",
								data: '2023-09-13',
								detail: " 9月12日，公司总裁陈海涛，易交易科技公司副总经理蒋涵湜，鼎函科技新疆分公司总经理陈晶等一行，拜访了新疆自治区产权交易所限责任公司",
							},
							{
								id: 20230902,
								title: "鼎函科技受邀参加京津冀协同招商推介暨投资北京全球峰会",
								data: '2023-09-02',
								detail: " 9月2日，2023年京津冀协同招商推介暨投资北京全球峰会在北京国家会议中心召开，鼎函科技有限公司总裁陈海涛先生受邀参加",
							},
							{
								id: 20230831,
								title: "喜报：鼎函科技新疆分公司成功准入！",
								data: '2023-08-31',
								detail: " 8月30日，中国铁路乌鲁木齐局集团有限公司正式准入鼎函科技新疆分公司为该公司独家电子保函供应商。",
							},
							{
								id: 20230726,
								title: "热烈祝贺鼎函新疆分公司于“水磨杯”创新创业大赛中获二等奖。",
								data: '2023-07-26',
								detail: " 本次于创新创业大赛中获奖，是对我司新疆分公司不懈努力与卓越成果的肯定与认可。",
							},
							{
								id: 20230706001,
								title: "鼎函科技新平台系统上线。",
								data: '2023-07-06',
								detail: " 本次更新，让系统操作更加便捷，客户在登录、获取保函信息等环节更加简单。",
							},
							{
								id: 20230704002,
								title: "鼎函科技与中国通用招标网成功对接。",
								data: '2023-07-04',
								detail: " 6月29日，鼎函科技有限公司与中技国际招标有限公司成功对接系统并正式上线。",
							},
							{
								id: 20230525001,
								title: "鼎函科技总裁陈海涛率团队赴中铁建鲁班网交流学习。",
								data: '2023-05-27',
								detail: "5月17日，鼎函科技总裁陈海涛率团队赴中铁建鲁班网交流学习。鲁班网吕兆峰、郭艳红等领导于中铁西城大厦接待了陈总裁一行",
							},
							{
								id: 20230507001,
								title: "鼎函科技荣获中国招标投标企业信用公示3A级信用等级",
								data: '2023-04-27',
								detail: "4月27日，鼎函科技通过国家级3A招投标信用评级，此次获得3A信用等级，有利于后续更多招投标项目的顺利开展，",

							},
							{
								id: 20230315001,
								title: "鼎函科技有限公司与中技国际招标有限公司签署电子保函/保单业务合作协议",
								data: '2023-04-27',
								detail: "近日，鼎函科技有限公司与中技国际招标有限公司签署电子保函/保单业务合作协议。",
							},
							{
								id: 20230314001,
								title: "鼎函电子保函平台获得和田地区行政服务和公共资源交易中心准入",
								data: '2023-03-14',
								detail: "3月13日，经新疆和田地区行政服务和公共资源交易中心批准，鼎函科技有限公司电子保函平台获得准入。",
							},
							{
								id: 20230307001,
								title: "简讯",
								data: '2023-03-07',
								detail: " 近日，鼎函科技有限公司执行总裁陈海涛在京接待了华商银行保函中心负责人高升武一行，",
							},
						],
					},
					{
						id: 2,
						kind: "政策解读",
						list: [{
                id: 20250515,
                title: "变“冻资”为“活水”，四地新政释放千亿级流动资金",
                data: '2025-05-15',
                detail: "2025年开年以来，安徽、广东、湖南、西藏等地陆续发布新规，明确要求大力推广保函（保险）替代现金缴纳保证金",
            },{
                id: 20250304,
                title: "北京加速布局具身智能与未来产业",
                data: '2025-03-04',
                detail: "北京近期在人工智能和具身智能领域的投资布局，展现了其在未来产业竞争中的雄心壮志。通过设立总规模1000亿元的政府投资基金",
            },{
                id: 20241218,
                title: "贵州省发改委等十二厅局联合发文，在招投标领域深化人工智能应用，持续推广电子保函",
                data: '2024-12-18',
                detail: "贵州省发展改革委等部门关于印发《贵州省创新完善体制机制推动招标投标市场规范健康发展的实施意见》的通知（黔发改法规〔2024〕706号）",
            },{
								id: 20241015,
								title: "保函（保险）替代保证金，为中小企业纾困",
								data: '2024-10-15',
								detail: "国务院新闻办公室于10月14日举行新闻发布会",
							},
							{
								id: 20241009,
								title: "鼎函科技：专注网络数据安全，守护用户信息资产",
								data: '2024-10-09',
								detail: "政府于今年9月24日出台《网络数据安全管理条例》",
							},
							{
								id: 20240910,
								title: "住建部将重点完善建设工程招投标等基础性制度",
								data: '2024-09-10',
								detail: "国务院新闻办公室近日举行了“推动高质量发展”系列主题新闻发布会",
							},
							{
								id: 20240903,
								title: "解锁科技新时代的秘方——鼎函AI",
								data: '2024-09-03',
								detail: "近日，为深入贯彻落实党的二十届三中全会精神，加快数字化绿色化协同转型发展，印发《实施指南》",
							},
							{
								id: 20240829,
								title: "财政部对十四届全国人大二次会议第1214号建议的答复",
								data: '2024-08-29',
								detail: "近日，财政部发布文章《财政部对十四届全国人大二次会议第1214号建议的答复》",
							},
							{
								id: 20240820,
								title: "扩展电子保函领域规模 推动科技金融高质量发展",
								data: '2024-08-20',
								detail: "党的二十届三中全会审议通过的《中共中央关于进一步全面深化改革、推进中国式现代化的决定》就深化金融体制改革作出部署。",
							},
							{
								id: 20240731,
								title: "关于规范中央企业采购管理工作的指导意见来了！",
								data: '2024-07-31',
								detail: "2023年中央企业采购金额高达20多万亿，在此背景下，为进一步规范中央企业采购管理工作",
							},
							{
								id: 20240507,
								title: "问题找准找细 整改从严从实 内蒙古自治区公共资源交易领域突出问题专项整治有序推进",
								data: '2024-05-07',
								detail: "近日，内蒙古自治区公共资源交易领域突出问题专项整治行动工作组办公室为全面整治公共资源交易领域突出问题",
							},
							{
								id: 20240418,
								title: "地方新政 | 支持建筑业企业十条措施 加快推行电子保函，缓解企业流动资金压力",
								data: '2024-04-18',
								detail: "陕西省住建厅、陕西省交通厅、陕西省水利厅、陕西省通信管理局联合印发《支持建筑业企业强信心稳增长促转型十条措施》",
							},
							{
								id: 20240403,
								title: "八部门联合出台重磅文件 招标投标政策出台前须进行公平竞争审查",
								data: '2024-04-03',
								detail: "针对一些企业反映的“投标难、中标难”等问题，国家发展改革委等8部门近日联合印发《招标投标领域公平竞争审查规则》",
							},
							{
								id: 20240305,
								title: "政府工作报告极简版来了",
								data: '2024-03-05',
								detail: "3月5日，李强总理向十四届全国人大二次会议作政府工作报告，要点如下：",
							},
							{
								id: 20240208,
								title: "两部门发文：这个领域全面推广保函（保险）！",
								data: '2024-02-08',
								detail: "近日，山西省发展和改革委员会、山西省行政审批服务管理局联合发布",
							},
							{
								id: 20231221,
								title: "江苏省：关于在全省政府采购领域推行电子履约保函(保险)的通知",
								data: ' 2023-12-21',
								detail: "为进一步优化政府采购营商环境，规范我省政府采购履约保证金管理，持续降低供应商参与政府采购成本",
							},
							{
								id: 20230830001,
								title: "陕西省：鼓励民营企业发展，大力推动使用保函",
								data: ' 2023-08-30',
								detail: "为切实规范招标代理行为，改进招标代理机构比选活动，8月18日，四川省发展和改革委员会、四川省住房和城乡建设厅",
							},
							{
								id: 20230829001,
								title: "北京市政府：深化公共资源交易平台整合共享",
								data: ' 2023-08-29',
								detail: "上月，北京市人民政府发表了《北京市贯彻落实加快建设全国统一大市场意见的实施方案》",
							},
							{
								id: 20230824001,
								title: "四川省九部门联合发文： 规范招标代理服务行为",
								data: ' 2023-08-24',
								detail: "为切实规范招标代理行为，改进招标代理机构比选活动，8月18日，四川省发展和改革委员会、四川省住房和城乡建设厅",
							},
							{
								id: 20230710001,
								title: "国家应急管理部：充分发挥安全生产责任保险功能作用",
								data: ' 2023-07-10',
								detail: "7月7日，应急管理部办公厅与国家金融监督管理总局办公厅联合向各省、自治区、直辖市应急管理厅（局）",
							},
							{
								id: 20230330001,
								title: "工信部发声 促进民营经济发展壮大",
								data: ' 2023-03-30',
								detail: "3月28日，第三届两化融合暨数字化转型大会在江苏苏州召开。会议中，工信部提出“引导和支持民营企业、平台企业参与国家重大",
							},
							{
								id: 20230323001,
								title: "鼓励支持民营经济和民营企业发展壮大",
								data: ' 2023-03-23',
								detail: "二十大以来，国家针对民营企业发展中遇到的市场开拓难、转型难、融资难等问题，提出“优化民营企业发展环境，依法保护民营企业产",
							},
							{
								id: 20230309001,
								title: "数字经济成为拉动增长新引擎",
								data: ' 2023-03-09',
								detail: "近年来，平台经济作为数字经济的代表在我国快速发展，在带动就业创业、拓展消费市场、创新生产模式等方面发挥重要作用。",
							},
							{
								id: 20230209001,
								title: "公共资源交易平台和企业招标采购平台试运行招标投标领域数字证书跨区域兼容互认",
								data: ' 2023-02-09',
								detail: "2023年2月6日国家发改委正式发布关于在部分地方公共资源交易平台和企业招标采购平台试运行招标投标领域数字证书跨区域兼容互认功能的通知。",
							},
							{
								id: 20230204001,
								title: "四川发布6方面22项举措，进一步规范招标投标主体行为！",
								data: '2023-02-04',
								detail: " 为进一步规范招标投标主体行为，维护公平竞争的市场秩序，12月27日，四川省人民政府办公厅发布《关于持续优化营商环境规",
							},
						]
					},
					{
						id: 3,
						kind: "行业资讯",
						list: [{
                id: 20250507,
                title: "电子保函vs传统保证金，一场关于企业成本的“数字革命”",
                data: '2025-05-07',
                detail: "电子保函正以摧枯拉朽之势，重塑着企业现金流的底层逻辑。",
            }, {
                id: 20250121,
                title: "以科技为内核，赋能金融发展",
                data: '2025-01-21',
                detail: "电子保函与人工智能的结合，为电子保函领域带来了新的活力和机遇。",
              }, {
								id: 20241204,
								title: "济南公共资源交易中心平阴分中心：大力推广电子保函助企纾困",
								data: '2024-12-04',
								detail: "济南公共资源交易中心平阴分中心，在公共资源交易活动中大力推广电子保函应用",
							}, {
								id: 20241201,
								title: "关于新修订的《北京市优化营商环境条例》",
								data: '2024-12-01',
								detail: "11月29日，市十六届人大常委会第十三次会议闭幕，表决通过新修订的《北京市优化营商环境条例》。",
							}, {
								id: 20241114,
								title: "靖安县：多措并举 稳步推进招投标营商环境",
								data: '2024-11-14',
								detail: "推广电子保函应用，减轻投标人资金负担。",
							},
							{
								id: 20241031,
								title: "【国家发改委——向民营企业进一步开放国家重大科研基础设施】",
								data: '2024-10-31',
								detail: "《决定》强调，向民营企业进一步开放国家重大科研基础设施。",
							},
							{
								id: 20240913,
								title: "洞见未来 鼎函深度“拥抱”人工智能",
								data: '2024-09-13',
								detail: "今年来，国资委多次“点题”人工智能，鼓励国资央企带头加快布局",
							},
							{
								id: 20240827,
								title: "【鼎函科技：引领科技金融新纪元，大数据模型赋能未来】",
								data: '2024-08-27',
								detail: "大数据模型是解锁未来金融服务的钥匙，而科技金融则是推动社会经济高质量发展的强大引擎。",
							},
							{
								id: 20240814,
								title: "顺应经济发展趋势，打造科技金融新产业",
								data: '2024-08-14',
								detail: "鼎函科技有限公司在顺应经济发展趋势，进行电子保函业务经营方面，展现了其前瞻性和创新性，打造科技金融类新的风向标。",
							},
							{
								id: 20240723,
								title: "常州市财政局：进一步推行电子履约保函（保险）",
								data: '2024-07-23',
								detail: "7月1日，常州市财政局下发《常州市财政局关于在全市政府采购领域进一步推行电子履约保函(保险)的通知》",
							},
							{
								id: 20240709,
								title: "国务院办公厅关于印发《政府采购领域“整顿市场秩序、建设法规体系、促进产业发展”三年行动方案（2024—2026年）》的通知",
								data: '2024-07-09',
								detail: "为打造市场化法治化国际化营商环境，加快现代化产业体系建设，推动经济社会高质量发展",
							},
							{
								id: 20240509,
								title: "国务院再次强调：全面推广电子保函（保险）应用！",
								data: '2024-05-09',
								detail: "5月8日，国务院下发《国务院办公厅关于创新完善体制机制推动招标投标市场规范健康发展的意见》",
							},
							{
								id: 20240402,
								title: "总投资近10万亿元！2024年重大项目大爆发（附清单）",
								data: '2024-04-02',
								detail: "开年以来，各地以重大项目为抓手“拼经济”，纷纷提前发布重大项目清单",
							},
							{
								id: 20240314,
								title: "广西自治区财政厅印发《关于在政府采购活动中推广使用电子保函的通知》",
								data: '2024-03-14',
								detail: "近日，广西自治区财政厅印发《关于在政府采购活动中推广使用电子保函的通知》",
							},
							{
								id: 20240118,
								title: "合肥市公管局多项举措惠企便民助力优化营商环境",
								data: '2024-01-18',
								detail: "为深化公共资源交易领域“放管服”改革，降低市场主体交易成本，合肥市公共资源交易监督管理局推出",
							},
							{
								id: 20231219,
								title: "广西壮族自治区财政厅关于在政府采购活动中推广使用电子保函的通知",
								data: '2023-12-19',
								detail: "贯彻落实《财政部 工业和信息化部关于印发〈政府采购促进中小企业发展管理办法〉的通知》",
							},
							{
								id: 20231218,
								title: "最新！国资委：对国有资产管理中股权转让、32号令适用等21个问题的集中回复（2023年12月）",
								data: '2023-12-18',
								detail: "国务院国资委对国有资产管理问题的回复",
							},
							{
								id: 20231215,
								title: "保险公司要公示安责险承保规模，2024年3月1日起实施！",
								data: '2023-12-15',
								detail: "近日，厦门市建设局、应急管理局、国家金融监督管理总局厦门监管局三部门联合印发",
							},
							{
								id: 20231213,
								title: "发改委：推动惠企政策落实，全面推行保函（保险）替代现金保证金",
								data: '2023-12-13',
								detail: "近日，国家发展改革委有关负责同志在答记者问中回应道：涉企收费直接关系市场主体切身利益",
							},
							{
								id: 20230914,
								title: "资讯直通车|上海交易集团盛装来袭！",
								data: '2023-09-14',
								detail: "2023年9月8日，上海市政府官网发布上海市人民政府关于同意组建上海交易集团有限公司的批复",
							},
							{
								id: 20230907,
								title: "资讯直通车",
								data: '2023-09-07',
								detail: "2023年9月1日，得知某省产权交易中心阳光采购服务平台出现“中标人弃标违约”情况",
							},
							{
								id: 20230804,
								title: "多地发文：全面推行保函（保险）代替保证金",
								data: ' 2023-08-04',
								detail: "自去年至今，多地再度强调，全面推行保函（保险）代替现金保证金。",
							},
							{
								id: 20230802,
								title: "广东首单电子履约保函业务落地",
								data: ' 2023-08-02',
								detail: "近日，广东政府采购智慧云平台（以下简称智慧云平台）金融服务中心成功开立首笔政府采购电子履约保函",
							},
							{
								id: 20230728,
								title: "十一部门联合提出开展招投标领域问题专项治理",
								data: ' 2023-07-28',
								detail: "近日，国家发展和改革委员会、工业和信息化部、住房和城乡建设部等十一个部门联合提出",
							},
							{
								id: 2023072601,
								title: "湖南推出农民工工资线上监管服务",
								data: ' 2023-07-26',
								detail: "7月12日，湖南省保障农民工工资支付综合服务平台暨“安薪务工”平台在全省上线。",
							},
							{
								id: 20230704001,
								title: "云南省多部门联合通知：大力推行电子保函",
								data: ' 2023-07-04',
								detail: "云南省为降低中小微企业交易成本，优化招标投标领域营商环境，省发展改革委、省工信厅、省住建厅等部门于今年年中联合",
							},
							{
								id: 20230615001,
								title: "深圳市：全面推广电子保函（保险）",
								data: ' 2023-06-14',
								detail: "36月1日，深圳市住房和建设局发表了《深圳市住房和建设局关于推行差异化缴纳投标保证金进一步",
							},
							{
								id: 20230609001,
								title: "银保监会：保险业要进一步向数字化转型",
								data: ' 2023-06-09',
								detail: "近年来，越来越多的保险公司开始在金融科技方面加大投入。一方面，大数据、人工智能等新技术",
							},
							{
								id: 20230607001,
								title: "北京市鼓励施工单位用保函形式办理农民工工资保证金",
								data: ' 2023-06-07',
								detail: "为了促进保市场主体保就业保民生，加大助企纾困稳岗力度，北京市人力资源和社会保障局推进三项举措帮助企业复工复产。",
							},
							{
								id: 20220531001,
								title: "怎样满足员工生活保障？保险产品要“因时生新”，北京银保监局有了新要求！",
								data: ' 2022-05-31',
								detail: "近日，北京银保监局明确提出要北京保险业积极创新保险产品，支持首都疫情防控、民生保障和企业正常经营。",
							},
							{
								id: 20220530001,
								title: "怎样防范工程施工安全？看看住建厅是怎么说的！",
								data: ' 2022-05-30',
								detail: " 近日，内蒙古自治区住房和城乡建设厅正式发文，明确实施工程施工安全生产责任保险，建立健全自治区建筑施工安责险事故。",
							},
						]
					},
					{
						id: 4,
						kind: "干货分享",
						list: [{
                id: 20250213,
                title: "以数据作为人工智能的食粮：揭秘智能时代的\"石油\"",
                data: ' 2025-02-13',
                detail: "数据，如同AI的食粮，为其提供源源不断的能量，驱动着这场智能革命。",
              },{
								id: 20240730,
								title: "国家发展改革委：《关于规范中央企业采购管理工作的指导意见》的通知",
								data: ' 2024-07-30',
								detail: "全面提升中央企业采购与供应链管理水平，提出以下意见。",
							},
							{
								id: 20240228,
								title: "关于印发《新疆维吾尔自治区房屋建筑和市政基础设施工程施工评标办法》",
								data: ' 2024-02-28',
								detail: "为进一步规范自治区、新疆生产建设兵团房屋建筑和市政基础设施工程招标评标活动，持续优化自治区",
							},
							{
								id: 20230220001,
								title: "食责险—让食安无忧",
								data: ' 2023-02-17',
								detail: "“民以食为天,食以安为先”,食品安全是生存和健康的第一屏障,关系国计民生。随着国家层面和各部委层面相继出台",
							},
							{
								id: 20221202001,
								title: "农民工工资支付保险来了～ 老板们还等啥",
								data: '  2022-12-02',
								detail: "缓解企业压力、解决欠薪难题2016年6月，国务院办公厅发布《关于清理规范工程建设领域保证金的通知》",
							},
							{
								id: 20221218001,
								title: "食品安全责任险—守护大家舌尖上的安全",
								data: ' 2022-12-18',
								detail: "“老板，你们的食责险到期了。2023年记得续保，对你们和顾客都有保障。”那么，什么是食品安全责任险呢？",
							},
							{
								id: 20220620001,
								title: "无效无效无效！今天开始，这些招标要求全部否决！",
								data: ' 2022-05-31',
								detail: "考证苦兮兮，发证笑嘻嘻，结果无效哭兮兮，这是不是你最近的状态？从今年1月1日开始，根据国家明确要求",
							},
							{
								id: 20220610001,
								title: "废标≠投标无效！这些资讯请收好！",
								data: '  2022-06-10',
								detail: " 对于政府采购从业者来说，用语规范是基本要求。用语不规范，同行两行泪。",
							},
						]
					},
					{
						id: 5,
						kind: "时事热点",
						list: [{
                id: 20250514,
                title: "招标投标法修订提上重要立法日程",
                data: '2025-05-14',
                detail: "5月14日，国务院办公厅发布《国务院2025年度立法工作计划》。由国家发展改革委负责起草的《招标投标法修订草案》",
            },{
                id: 20250428,
                title: "区块链+供应链金融：跨境金融服务再升级",
                data: '2025-04-28',
                detail: "近日，中国人民银行联合金融监管总局、国家外汇局及上海市人民政府共同发布《上海国际金融中心进一步提升跨境金...",
            },{
                id: 20250417,
                title: "北京：市场更开放 参与更便利 服务更智能",
                data: '2025-04-17',
                detail: "北京市自2017年开展优化营商环境改革以来，全力打造“市场更开放、参与更便利、服务更智能”的政府采购营商环境",
            },{
                id: 20250409,
                title: "从“互联网+“到“人工智能+“：政府采购智能化变革趋势",
                data: '2025-04-09',
                detail: "随着人工智能技术的爆发，“人工智能+”正在为政府采购注入新的智慧基因，让原本繁琐、低效甚至存在灰色地带的环节变得透明",
            },{
                id: 20250401,
                title: "重磅 | 中办、国办印发《健全社会信用体系意见》公共资源交易、政府采购、招标投标是重要领域",
                data: '2025-04-01',
                detail: "为健全社会信用体系，中共中央办公厅、国务院办公厅近日印发《关于健全社会信用体系的意见》。其中，公共资源交易",
            },{
                id: 20250327,
                title: "从政策引导到法规约束，电子保函从“力推”到“应当”",
                data: '2025-03-27',
                detail: "日前，国务院总理李强签署国务院令，公布修订后的《保障中小企业款项支付条例》（以下简称《条例》），自2025年6月1日起施行。",
            },{
                id: 20250326,
                title: "聚焦中国发展高层论坛2025：鼎函科技以创新驱动数字经济未来",
                data: '2025-03-26',
                detail: "3月23日至24日，中国发展高层论坛2025年年会在北京举行，国家数据局党组书记、局长刘烈宏明确提出",
            },{
                id: 20250217,
                title: "民营经济新篇章：前景无限，大有可为",
                data: '2025-02-17',
                detail: "2025年2月17日，中共中央总书记、国家主席、中央军委主席习近平在京主持召开了民营企业座谈会，并发表了鼓舞人心的讲话。",
              },{
								id: 20241001,
								title: "盛世华诞 举国同庆——鼎函科技祝祖国母亲生日快乐",
								data: '2024-10-01',
								detail: "鼎函科技祝大家国庆快乐",
							},
							{
								id: 20240915,
								title: "中秋佳节至，良辰共此时——来自鼎函的中秋问候",
								data: '2024-09-15',
								detail: "鼎函科技祝大家中秋快乐",
							},
							{
								id: 20240414,
								title: "218人串通投标被抓！山东通报招标投标领域违法典型案例",
								data: '2024-04-14',
								detail: "4月10日，山东省发改委网站发布《山东省发展和改革委员会 山东省公安厅关于招标投标领域违法典型案例的通报》",
							},
							{
								id: 20231220,
								title: "涉案人员700余人，内蒙古一地严查专家评审乱象 整治公共资源交易领域腐败",
								data: '2023-12-20',
								detail: "截至目前，赤峰市公共资源交易领域相关涉案人员达700余人，涉及项目标的额44亿余元",
							},
							{
								id: 20231128,
								title: "警惕！230家企业被永久拉黑",
								data: '2023-11-28',
								detail: "日前，国际能源网/光伏头条（PV-2005）梳理后发现，在大唐集团1-11批公布的不良供应商中",
							},
							{
								id: 20231016,
								title: "吉林省：严禁施工单位垫资施工 确保按时足额支付工资",
								data: '2023-10-16',
								detail: "近日，吉林省在全省工程建设领域开展“薪安吉林”活动。该活动旨在强化企业工资支付的主体责任",
							},
							{
								id: 2023072602,
								title: "山东省：规范农民工工资支付监管平台管理",
								data: ' 2023-07-26',
								detail: "近日，为规范农民工工资支付监管平台管理，提升保障农民工工资支付工作数字化、智慧化水平，",
							},
							{
								id: 20230621001,
								title: "国家发展改革委等部：全面推广保函（保险）",
								data: ' 2023-06-21',
								detail: "5月31日，国家发展改革委、工业和信息化部、财政部、人民银行联合发表了",
							},
							{
								id: 20230601001,
								title: "全国推行：“区块链+电子保函”未来将进一步取代保证金",
								data: ' 2023-06-01',
								detail: "“据海南省人民政府办公厅网站消息，实施“机器管招投标”制度。完成“机器管招投标”系统建设",
							},
							{
								id: 20230224001,
								title: "《安责险》------为企业扣紧“安全带”",
								data: '  2023-02-24',
								detail: "2023年2月22日，内蒙古自治区阿拉善盟阿拉善左旗新井煤业有限公司露天煤矿发生大面积坍塌",
							},
							{
								id: 20220517001,
								title: "120亿元的罪——侨兴债背后的保险危机",
								data: '  2022-05-17',
								detail: "2017年银监发表通报并披露，广发银行惠州分行员工与侨兴集团人员内外勾结、私刻公章、违规担保案件",
							},
						]
					},
				/*	{
						id: 6,
						kind: "收费标准",
					}*/ // todo
				],
				news: [],
				itemId: null, // 文章id
				payNo: null, // 微信支付付款单号
				qrcodeVisible: false,
				qrcodeUrl: "",
				loginVisible: false,
				timer: null,
			};
		},
		computed: {},
		watch: {
			$route: {
				handler: function(val) {
					this.tabIndex = val.query.tabIndex;
				},
				// 深度观察监听
				deep: true,
			},
		},
		methods: {
			handClick(tabIndex) {
				this.tabIndex = tabIndex
			},
			clickArticle(item, id) {
				if (id === 4) {
					// 验证文章权限
					this.validArticle(item.id)
				} else {
					clearInterval(this.timer)
					this.goArticle(item.id)
				}
			},
			async validArticle(id) {
				const phone = sessionStorage.getItem("phone");
				if (phone) {
					const res = await this.checkPay(id)
					if (res.data.resultCode == '200') {
						const {
							payNo,
							status
						} = res.data.data // status：0-未交费，1-已缴费
						if (status == 1) this.goArticle(id)
						else {
							this.payNo = payNo
							this.goPay(id)
						}
					} else {
						this.$message.error(res.data.repMsg)
					}
				} else {
					this.loginVisible = true
					this.itemId = id
				}
			},
			// 打开二维码付款
			goPay(id) {
				clearInterval(this.timer)
				this.qrcodeVisible = true
				this.itemId = id
				this.loopCheckPay(id)
			},
			goArticle(id) {
				let url = this.getArticleUrl(id)
				window.open(url)
			},
			getArticleUrl(id) {
				// let  url = 'https://dinghanwang.com/info/archives/'+id
				return 'https://news.dinghanwang.com/archives/' + id
			},
			// 短信验证码成功回调
			phoneLoginCallback(id) {
				this.loginVisible = false
				this.validArticle(id)
			},
			// 付款弹窗关闭回调
			qrcodePayCallback() {
				this.qrcodeVisible = false
			},
			// 轮询检查付款状态
			loopCheckPay(id) {
				this.timer = setInterval(async () => {
					let res = await this.checkPay(id)
					const {
						status
					} = res.data.data // status：0-未交费，1-已缴费
					if (status == 1) {
						this.$message.success('付款成功')
						this.qrcodeVisible = false
						clearInterval(this.timer)
						setTimeout(() => {
							this.goArticle(id)
						}, 1000);
					}
				}, 5000);
			},
			// 验证是否付费
			async checkPay(id) {
				const params = {
					phone: sessionStorage.getItem("phone"),
					url: this.getArticleUrl(id)
				}
				const ret = await checkPay(params)
				return ret
			}
		},
		created() {
			let tabIndex = this.$route.query.tabIndex;
			this.tabIndex = tabIndex;
			clearInterval(this.timer)
		},
		beforeDestroy() {
			clearInterval(this.timer)
		},
	};
</script>

<style scoped>
	.news {
		width: 1200px;
		margin: auto;
	}

	.news_from {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		margin-bottom: 20px;
	}

	.news_Location {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		margin-left: 100px;
	}

	.news_Location_item {
		margin-right: 15px;
		color: #000;
		cursor: pointer;
		display: flex;
		align-items: center;
	}

	.news_Location_item img {
		height: 22px;
		margin-right: 3px;
	}

	.news_Location_item .icon-standard {
		height: 26px;
	}

	.news_con {
		margin: 50px 0;
	}

	.news_con_item {
		display: flex;
		align-items: flex-start;
		margin-bottom: 30px;
		cursor: pointer;
	}

	.news_con_time {
		margin-right: 30px;
	}

	.news_title {
		font-weight: 600;
		display: flex;
		align-items: center;
	}

	.news_title img {
		height: 22px;
		margin-right: 5px;
	}

	.news_text:hover {
		color: rgb(26, 127, 221);
	}

	.standard_con {
		margin: 50px 0 50px 165px;
		font-size: 16px;
	}

	.standard_con table {
		width: 500px;
		border-collapse: collapse;
		margin: 20px 0;
	}

	.standard_con th,
	.standard_con td {
		border: 1px solid #ddd;
		padding: 8px;
		text-align: left;
	}

	.standard_con th {
		background-color: #f2f2f2;
	}

	.standard_con img {
		height: 22px;
	}

	.standard_con h2 {
		font-weight: bold;
		margin-bottom: 10px;
		margin-top: 15px;
	}

	.standard_con p {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}
</style>
